import { useId } from "react";

/**
 * The logo's winding path as a route line over a faint street grid (board 298's panel). Decorative: no words, hidden from readers.
 * Colours are the brand tokens; the line mirrors in Hebrew through the frame's own flip.
 */
export const RouteArt = ({ className }: { className?: string }) => {
  const id = useId().replace(/:/g, "");
  return (
    <svg className={className} viewBox="0 0 540 800" preserveAspectRatio="xMidYMax slice" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id={`${id}f`} x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor="white" stopOpacity="0" /><stop offset=".45" stopColor="white" stopOpacity=".9" /></linearGradient>
        <mask id={`${id}m`}><rect width="540" height="800" fill={`url(#${id}f)`} /></mask>
      </defs>
      <g mask={`url(#${id}m)`} style={{ stroke: "var(--cy-divider)" }} strokeWidth="1.5" fill="none">
        {[110, 230, 350, 470].map((x) => <path key={x} d={`M${x} 300 L${x + 60} 800`} />)}
        {[400, 500, 600, 700].map((y) => <path key={y} d={`M0 ${y} L540 ${y - 30}`} />)}
      </g>
      <path d="M-30 800 C120 790 70 660 210 630 C350 600 450 600 430 520 C410 450 500 420 580 410" fill="none" strokeWidth="18" strokeLinecap="round" style={{ stroke: "var(--cy-info-bg)" }} />
      <path d="M-30 800 C120 790 70 660 210 630 C350 600 450 600 430 520 C410 450 500 420 580 410" fill="none" strokeWidth="6" strokeLinecap="round" style={{ stroke: "var(--cy-primary)" }} />
      {[[70, 705], [210, 630]].map(([x, y]) => <circle key={x} cx={x} cy={y} r="8" strokeWidth="4" style={{ fill: "var(--cy-surface)", stroke: "var(--cy-primary)" }} />)}
      <circle cx="430" cy="520" r="9" strokeWidth="4" style={{ fill: "var(--cy-surface)", stroke: "var(--cy-primary)" }} />
      <circle cx="470" cy="418" r="11" strokeWidth="5" style={{ fill: "var(--cy-brand-teal)", stroke: "var(--cy-surface)" }} />
    </svg>
  );
};

/** Two sample product cards, drawn as shapes only (no invented words). */
export const SampleCards = ({ className }: { className?: string }) => (
  <div className={className} aria-hidden="true">
    <div data-card="route"><span data-ico /><span data-bar="1" /><span data-bar="2" /></div>
    <div data-card="visit"><span data-ico="ok" /><span data-bar="1" /><span data-bar="3" /></div>
  </div>
);
